module.exports = __webpack_public_path__ + "assets/img/523ae8fee57bd4abdf53502cf5da06ac.svg";